import { IHttpService, IPromise, IQService } from 'angular';
import HttpService from '../../common/services/http.service';
import { Invoice } from './invoice.model';
import { Card, AddNewCardResponse } from './card.model';
import {
  PackageThumbnail,
  Payment,
  ListeningPackageType,
  CancelSubscriptionType,
  HashRequestResponse,
  CheckChurnResponse
} from '../../common/services/package/package.model';
import { PaymentMethod } from './payment-method.model';

/* @ngInject */
export class PaycellService {
  private paycellConfig;
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private config,
    private i18n,
    private $q: IQService
  ) {
    this.paycellConfig = config.paycell;
  }

  public getCards(): IPromise<PaymentMethod[]> {
    return this.httpService
      .extractResponseResult(
        this.$http.post(`hafifmuzik/mobile/paycell/getCreditCardList`, null),
        false
      )
      .then(response => response.paymentMethodsWithAlias);
  }

  public createPaymentMethod(
    sessionId: string,
    token: string,
    alias: string
  ): IPromise<string> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/createPaymentMethod`,
        `alias=${alias}`,
        {
          headers: {
            'X-ThreeD-Session-Id': sessionId,
            'X-Paycell-Card-Token': token,
            'content-type': 'application/x-www-form-urlencoded'
          },
          timeout: 45000
        }
      )
    );
  }

  public threeDSecure(
    sessionId: string,
    redirectUrl: string
  ): IPromise<string> {
    return this.httpService.extractResponseData(
      this.$http.post(
        `${this.paycellConfig.url}/paymentmanagement/rest/threeDSecure`,
        `threeDSessionId=${sessionId}&channelId=93&callbackurl=${redirectUrl}`,
        {
          headers: { 'content-type': 'application/x-www-form-urlencoded' }
        }
      )
    );
  }

  public get3DSessionResult(sessionId: string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/get3DSessionResult`,
        {},
        {
          headers: {
            'X-ThreeD-Session-Id': sessionId
          }
        }
      )
    );
  }

  public get3DSessionIDForChangePayment(token: string, packet: PackageThumbnail): IPromise<string> {
    if(packet && (packet.type === ListeningPackageType.SDP ||packet.type === ListeningPackageType.MOBILODEME)){
      return this.get3DSessionID(token, packet.id);
    } else{
      return this.get3DSessionID(token, '');
    }
  }

  public get3DSessionIDForUpdate(offerId: string, paymentMethodID: number, cardId?: string): IPromise<string> {
    return this.get3DSessionID(undefined, offerId, paymentMethodID, cardId);
  }

  public get3DSessionID(token: string, offerId: string, paymentMethodID?: number, cardId?: string): IPromise<string> {
    //if offerId is empty or undefined that amount  will be 1 tl

    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/get3DSessionID`+ `?offerId=`+offerId ,
        { installmentCount: '0', paymentMethodId: paymentMethodID, cardId: cardId },
        {
          headers: {
            'X-Paycell-Card-Token': token
          },
          timeout: 45000
        }
      )
    );
  }

  public paymentHashData(): IPromise<HashRequestResponse> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/getHashData`,
        {}
      )
    );
  }

  public paymentRestToken(card: Card, hashDataResponse:HashRequestResponse): IPromise<AddNewCardResponse> {
    return this.httpService.extractResponseData(
      this.$http.post(
        `${this.paycellConfig.url}/paymentmanagement/rest/getCardTokenSecure`,
        { creditCardNo: card.ccNo, 
          expireDateMonth: card.expDateMonth,
          expireDateYear: card.expDateYear, 
          cvcNo: card.cvcNo, 
          hashData: hashDataResponse.hashData,
          header: {
            transactionId: hashDataResponse.transactionId,
            applicationName: this.paycellConfig.applicationName,
            transactionDateTime: hashDataResponse.transactionDateTime
          } 
        }
      )
    );
  }

  public deletePayment(paymentMethodID: number, cardId: string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(`hafifmuzik/mobile/paycell/cancelPaymentMethod`, {
        paymentMethodID, cardId
      })
    );
  }

  public deletePacket(targetPackage: PackageThumbnail): IPromise<CancelSubscriptionType> {
    return this.httpService.extractResponseResult(
      this.$http.post(`hafifmuzik/mobile/paycell/cancelSubscription`, {
        offerId: targetPackage.id,
        paymentMethodId: 1
      })
    );
  }


  public updatePaymentMethod(paymentMethodID: number, threedSessionId?: string, cardId?:string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(`hafifmuzik/mobile/paycell/updatePaymentMethod`, {
        paymentMethodID: paymentMethodID,
        cardId: cardId
      },
      {
        headers: !!threedSessionId ? {
          'X-ThreeD-Session-Id': threedSessionId,
        } : {},
        timeout: 45000
      })
    );
  }

  public updateSubscriptionMethod(paymentMethodID: number, cpcmOfferId: string, cardId: string): IPromise<boolean> {
    return this.executeWithRetry(() =>
      this.httpService.extractResponseResult(
        this.$http.post(`hafifmuzik/mobile/paycell/updateSubscriptionPayment`, {
          cpcmOfferId: cpcmOfferId,
          paymentMethodId: paymentMethodID,
          cardId: cardId
        }, {
          timeout: 60000
        }), true, true
      ),
      3
    );
  }



  public getContractByKey(key: string, offerId?: string): IPromise<string> {
    let url = `hafifmuzik/mobile/paycell/getContract?key=${key}`;
    let cacheKey = `getContract${key}`;
    if (!angular.isUndefined(offerId)) {
      url += `&offerId=${offerId}`;
      cacheKey += `&offerId=${offerId}`;
    }
    return this.httpService.getResultFromCache(cacheKey, url);
  }

  public getPaymentMethod(paymentMethodId?: number, cardId?: string): IPromise<Payment> {
    if(!!cardId){
      return this.httpService.getResultFromCache(`paycellPaymentMethods${cardId}`, `hafifmuzik/mobile/paycell/getPayment?cardId=${cardId}`);
    } else{
      return this.httpService.getResultFromCache(`paycellPaymentMethods${paymentMethodId}`, `hafifmuzik/mobile/paycell/getPayment?paymentId=${paymentMethodId}`);
    }
  }

  public getPaymentMethodIdByListening(offerId?: string): IPromise<string> {
    return this.httpService.getResultFromCache(`paycellPackagePaymentMethod${offerId}`,
        `hafifmuzik/mobile/paycell/getPaymentByOfferId?offerid=${offerId}`
    );
  }

  public validatePasswordAndBuy(
    packet: PackageThumbnail,
    paymentMethodId?: number,
    cardId?: string
  ): IPromise<Response> {
    return this.executeWithRetry(() =>
      this.httpService.extractResponseResult(
        this.$http.post(
          `hafifmuzik/mobile/paycell/checkPasswordAndPerformPayment`,
          {
            offerId: packet.id,
            paymentMethodId: paymentMethodId,
            cardId: cardId
          },
          {
            timeout: 60000
          }
        ), true, true
      ),
      3
    );
  }

  private executeWithRetry(fn: () => IPromise<any>, retries: number = 3): IPromise<any> {
    return fn().catch(error => {
      if (retries > 0) {
        return this.executeWithRetry(fn, retries - 1);
      }
      return this.$q.reject(error);
    });
  }

  public checkOfferBeforeChurn(offerId: string): IPromise<CheckChurnResponse> {
    return this.httpService.extractResponseResult(
      this.$http.post(
      `hafifmuzik/mobile/paycell/checkOfferBeforeChurn`,
      `offerId=${offerId}`,
      {
        headers: {
        'content-type': 'application/x-www-form-urlencoded'
        }
      }
      ), false, false
    );
  }

  public retentionOfferAccept(offerId: string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/retention`,
        `offerId=${offerId}`,
      {
        headers: {
        'content-type': 'application/x-www-form-urlencoded'
        }
      }
      ), true, false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/services/paycell.service.ts